export const createHighlightWorker = () => {
  if (window.Worker) {
    try {
      return new Worker('/js/hljs-worker.js')
    } catch (e) {
      console.error('Error instantiating worker:', e)
    }
  } else {
    console.error('Web Workers are not supported in this browser.')
  }
}

export const highlightWorker = createHighlightWorker()
